export default {
    API_URL: "https://mju-index.avalue.co.th/services/api",
    production: false,
    access_key: "mjuindex_web_token",
    refresh_key: "mjuindex_web_refresh_token",
}